/**
 * Verification product chrome — persistent ModeShell for all `/agents/*` product
 * routes (port of `app/agents/layout.tsx`).
 *
 * Registers ModeRail sub-nav (Verification · Readiness · legacy workflows ·
 * developer operations)
 * once for the whole Verification subtree so deep links inherit the rail without
 * per-page flicker.
 *
 * SWR warm-up is NOT this shell's job: `SurfaceBootstrapPreload`, mounted once
 * at the root inside `ShellSWRProvider`, warms the `agents` surface's bootstrap
 * keys (overview, analytics, health, goals, fleet) the first time the pathname
 * enters `/agents` — the Linear "context everywhere" model, one mount for every
 * surface. See `client/shell/product-swr-surfaces.ts`.
 */

import type { ReactNode } from "react";
import { ModeShell } from "@excellent/ui";
import { AGENTS_VIEWS } from "./agents-views";
import { AgentsModePulse } from "./mode-pulse";
import { getShellData } from "../../shell/shell-data";

export function AgentsProductShell({ children }: { children: ReactNode }) {
  const shell = getShellData();
  const pulseOn = shell.pulse.enabled;
  const pulseDynamic = shell.pulse.dynamic;

  return (
    <ModeShell
      mode="Verification"
      modeSlug="agents"
      modeHref="/agents"
      views={AGENTS_VIEWS}
      gutter={false}
      // Title bar always; gutter rail only when pulse.selfnav is on.
      pulse={
        <AgentsModePulse dynamic={pulseDynamic} gutter={pulseOn} />
      }
    >
      {children}
    </ModeShell>
  );
}
